const translations = {
  en: {
    dashboard: 'Dashboard', enterData: 'Enter data', expenses: 'Expenses',
    inventory: 'Inventory', aiAdvisor: 'AI advisor', settings: 'Settings',
    signOut: 'Sign out', totalRevenue: 'Total revenue', foodCostPct: 'Food cost %',
    laborCostPct: 'Labor cost %', netProfit: 'Net profit', daysTracked: 'days tracked',
    margin: 'Margin', target: 'Target', pandlSummary: 'P and L summary',
    foodSales: 'Food sales', beverageSales: 'Beverage sales', totalRevenueLine: 'Total revenue',
    foodCost: 'Food cost', beverageCost: 'Beverage cost', labor: 'Labor', rent: 'Rent',
    utilities: 'Utilities', other: 'Other', netProfitLine: 'Net profit',
    costBreakdown: 'Cost breakdown', avgCheck: 'Avg check', totalCovers: 'Total covers',
    downloadPL: 'Download P&L report (Excel)', vsPrevMonth: 'vs Previous month',
    vsSameLastYear: 'vs Same month last year', backToCurrentMonth: 'Back to current month',
    noDataYet: 'No data yet for this month.', goToEnterData: 'Go to Enter data to add your first sales entry.',
    weeklyTarget: 'Weekly revenue target', weeklyTargetReached: 'Target reached this week!',
    toGo: 'to go', ofWeeklyTarget: 'of weekly target',
    bestDay: 'Best day', worstDay: 'Worst day', busiestDay: 'Busiest day',
    covers: 'covers', foodCostAlert: 'Food cost alert', threshold: 'threshold',
    aboveTarget: 'above your target. Check your purchases and inventory.',
    approaching: 'Food cost approaching threshold', keepEye: 'Getting close to your alert threshold. Keep an eye on purchases.',
    addUpdateSales: 'Add or update daily sales', date: 'Date', coversGuests: 'Covers (guests)',
    foodSalesAmt: 'Food sales ($)', beverageSalesAmt: 'Beverage sales ($)',
    saveEntry: 'Save entry', saving: 'Saving...', saved: 'Saved!',
    thisMonth: 'This month', entries: 'entries', noEntriesYet: 'No entries yet this month.',
    edit: 'Edit', saveChanges: 'Save changes', cancel: 'Cancel',
    downloadExcel: 'Download Excel', editEntry: 'Edit entry',
    logExpense: 'Log an expense', category: 'Category', amount: 'Amount ($)',
    description: 'Description', saveExpense: 'Save expense', noExpensesYet: 'No expenses logged yet.',
    editExpense: 'Edit expense', subcategory: 'Subcategory', selectSubcategory: 'Select subcategory...',
    catFoodCost: 'Food cost', catBevCost: 'Bev cost', catLabor: 'Labor',
    catRent: 'Rent', catUtilities: 'Utilities', catMarketing: 'Marketing',
    catMaintenance: 'Maintenance', catOther: 'Other',
    meatSeafood: 'Meat & Seafood', produce: 'Produce', dairyEggs: 'Dairy & Eggs',
    dryGoods: 'Dry Goods & Pantry', otherFood: 'Other food', coffeeTea: 'Coffee & Tea',
    softDrinks: 'Soft Drinks', alcohol: 'Alcohol', otherBev: 'Other beverage',
    inventoryCount: 'Inventory count', openingInventory: 'Opening inventory - start of month',
    closingInventory: 'Closing inventory - end of month', totalOpening: 'Total opening',
    totalClosing: 'Total closing', saveOpeningInventory: 'Save opening inventory',
    saveClosingInventory: 'Save closing inventory', realFoodCost: 'Real food cost calculation',
    plusPurchases: 'Plus purchases from expenses tab', minusClosing: 'Minus closing inventory',
    inventoryVariance: 'Inventory variance', catMeatSeafood: 'Meat and Seafood',
    catProduce: 'Produce', catDairyEggs: 'Dairy and Eggs', catDryGoods: 'Dry Goods and Pantry',
    catBevCoffee: 'Beverages - Coffee and Tea', catBevSoft: 'Beverages - Soft Drinks',
    catBevAlcohol: 'Beverages - Alcohol', catBevOther: 'Other',
    aiAdvisorTitle: 'AI advisor powered by Claude', addDataFirst: 'Add sales data first to get AI insights.',
    analyzing: 'Analyzing your numbers...', claudeReviewing: 'Claude is reviewing your data.',
    readyToAnalyze: 'Ready to analyze', generateInsights: 'Generate AI insights',
    regenerateInsights: 'Regenerate insights', couldNotGenerate: 'Could not generate insights. Check your Anthropic API key.',
    benchmarks: 'Benchmarks: food cost 28-32% labor 28-35% prime cost under 60% net margin over 10% bev mix 25-35%',
    restaurantSettings: 'Restaurant settings', restaurantName: 'Restaurant name',
    currency: 'Currency', targetsAlerts: 'TARGETS AND ALERTS',
    weeklyRevenueTarget: 'Weekly revenue target ($)', weeklyTargetHint: 'Shows a progress bar on your dashboard each week',
    foodCostAlertThreshold: 'Food cost alert threshold (%)', foodCostAlertHint: 'Shows a warning when food cost % exceeds this number',
    language: 'Language', saveSettings: 'Save settings', errorSaving: 'Error saving. Please try again.',
    signIn: 'Sign in', signUp: 'Sign up', email: 'Email', password: 'Password',
    createAccount: 'Create account', alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?", pleaseWait: 'Please wait...',
    restaurantPL: 'Restaurant P&L and AI Advisor',
    welcomeTitle: 'Welcome to WinProfit! 👋', welcomeSub: "Let's set up your restaurant in 2 minutes.",
    continueBtn: 'Continue →', addFirstSale: 'Add your first sale 📊',
    addFirstSaleSub: "Enter today's sales to see your P&L dashboard come to life.",
    saveAndContinue: 'Save and continue →', skipForNow: 'Skip for now',
    skipSetup: 'Skip setup', allSet: "You're all set!", goToDashboard: 'Go to my dashboard →',
    stepOf: 'Step', of: 'of',
    freeTrial: 'Free trial', daysLeft: 'days left',
    trialExpired: 'Your free trial has ended. Choose a plan to continue.',
    trialActive: 'You have', daysLeftInTrial: 'days left in your free trial.',
    startFree: 'Start free for 30 days. No credit card required.',
    monthly: 'Monthly', yearly: 'Yearly', bestValue: 'Best value',
    subscribeMonthly: 'Subscribe monthly', subscribeYearly: 'Subscribe yearly',
    startFreeTrial: 'Start free trial', alreadyAccount: 'Already have an account?',
    action: 'Action', primeCost: 'Prime cost', bevMix: 'Bev mix',
    pleaseEnterDate: 'Please enter a date and at least one sales amount.',
    pleaseEnterDateAmount: 'Please enter a date and amount.',
    pleaseEnterName: 'Please enter a restaurant name.',
    errorDelete: 'Delete this entry?', errorDeleteExpense: 'Delete this expense?',
    dailyRevenue: 'Daily revenue', monthTrend: '6-month revenue trend',
    lastPeriod: 'Last period', revenue: 'Revenue', ofWeeklyTargetPct: 'of weekly target',
  },
  fr: {
    dashboard: 'Tableau de bord', enterData: 'Saisir données', expenses: 'Dépenses',
    inventory: 'Inventaire', aiAdvisor: 'Conseiller IA', settings: 'Paramètres',
    signOut: 'Déconnexion', totalRevenue: "Chiffre d'affaires", foodCostPct: 'Coût matière %',
    laborCostPct: "Coût main-d'œuvre %", netProfit: 'Bénéfice net', daysTracked: 'jours enregistrés',
    margin: 'Marge', target: 'Objectif', pandlSummary: 'Résumé P&L',
    foodSales: 'Ventes alimentaires', beverageSales: 'Ventes boissons',
    totalRevenueLine: "Chiffre d'affaires total", foodCost: 'Coût matière',
    beverageCost: 'Coût boissons', labor: "Main-d'œuvre", rent: 'Loyer',
    utilities: 'Charges', other: 'Autres', netProfitLine: 'Bénéfice net',
    costBreakdown: 'Répartition des coûts', avgCheck: 'Ticket moyen', totalCovers: 'Couverts total',
    downloadPL: 'Télécharger rapport P&L (Excel)', vsPrevMonth: 'vs Mois précédent',
    vsSameLastYear: "vs Même mois l'an dernier", backToCurrentMonth: 'Retour au mois actuel',
    noDataYet: 'Aucune donnée ce mois.', goToEnterData: 'Allez dans Saisir données pour ajouter votre première vente.',
    weeklyTarget: 'Objectif hebdomadaire', weeklyTargetReached: 'Objectif atteint cette semaine !',
    toGo: 'restants', ofWeeklyTarget: "de l'objectif hebdomadaire",
    bestDay: 'Meilleur jour', worstDay: 'Pire jour', busiestDay: 'Jour le plus chargé',
    covers: 'couverts', foodCostAlert: 'Alerte coût matière', threshold: 'seuil',
    aboveTarget: 'au-dessus de votre objectif. Vérifiez vos achats et inventaire.',
    approaching: 'Coût matière proche du seuil', keepEye: "Vous approchez du seuil d'alerte. Surveillez vos achats.",
    addUpdateSales: 'Ajouter ou modifier les ventes journalières', date: 'Date',
    coversGuests: 'Couverts (clients)', foodSalesAmt: 'Ventes alimentaires ($)',
    beverageSalesAmt: 'Ventes boissons ($)', saveEntry: 'Enregistrer', saving: 'Enregistrement...',
    saved: 'Enregistré !', thisMonth: 'Ce mois', entries: 'entrées',
    noEntriesYet: 'Aucune entrée ce mois.', edit: 'Modifier', saveChanges: 'Sauvegarder',
    cancel: 'Annuler', downloadExcel: 'Télécharger Excel', editEntry: "Modifier l'entrée",
    logExpense: 'Enregistrer une dépense', category: 'Catégorie', amount: 'Montant ($)',
    description: 'Description', saveExpense: 'Enregistrer la dépense',
    noExpensesYet: 'Aucune dépense enregistrée.', editExpense: 'Modifier la dépense',
    subcategory: 'Sous-catégorie', selectSubcategory: 'Choisir une sous-catégorie...',
    catFoodCost: 'Coût matière', catBevCost: 'Coût boissons', catLabor: "Main-d'œuvre",
    catRent: 'Loyer', catUtilities: 'Charges', catMarketing: 'Marketing',
    catMaintenance: 'Maintenance', catOther: 'Autres',
    meatSeafood: 'Viandes & Fruits de mer', produce: 'Fruits & Légumes',
    dairyEggs: 'Produits laitiers & Œufs', dryGoods: 'Épicerie sèche',
    otherFood: 'Autres aliments', coffeeTea: 'Café & Thé',
    softDrinks: 'Boissons non alcoolisées', alcohol: 'Alcool', otherBev: 'Autres boissons',
    inventoryCount: 'Comptage inventaire', openingInventory: "Inventaire d'ouverture - début de mois",
    closingInventory: 'Inventaire de fermeture - fin de mois',
    totalOpening: 'Total ouverture', totalClosing: 'Total fermeture',
    saveOpeningInventory: 'Sauvegarder inventaire ouverture',
    saveClosingInventory: 'Sauvegarder inventaire fermeture',
    realFoodCost: 'Calcul coût matière réel', plusPurchases: 'Plus achats (onglet dépenses)',
    minusClosing: 'Moins inventaire fermeture', inventoryVariance: 'Écart inventaire',
    catMeatSeafood: 'Viandes et Fruits de mer', catProduce: 'Fruits et Légumes',
    catDairyEggs: 'Produits laitiers et Œufs', catDryGoods: 'Épicerie sèche',
    catBevCoffee: 'Boissons - Café et Thé', catBevSoft: 'Boissons - Sans alcool',
    catBevAlcohol: 'Boissons - Alcool', catBevOther: 'Autres',
    aiAdvisorTitle: 'Conseiller IA propulsé par Claude',
    addDataFirst: 'Ajoutez des données de vente pour obtenir des conseils IA.',
    analyzing: 'Analyse de vos chiffres...', claudeReviewing: 'Claude analyse vos données.',
    readyToAnalyze: 'Prêt à analyser', generateInsights: 'Générer des conseils IA',
    regenerateInsights: 'Régénérer les conseils',
    couldNotGenerate: 'Impossible de générer. Vérifiez votre clé API Anthropic.',
    benchmarks: "Références : coût matière 28-32% main-d'œuvre 28-35% marge nette >10%",
    restaurantSettings: 'Paramètres du restaurant', restaurantName: 'Nom du restaurant',
    currency: 'Devise', targetsAlerts: 'OBJECTIFS ET ALERTES',
    weeklyRevenueTarget: 'Objectif CA hebdomadaire ($)',
    weeklyTargetHint: 'Affiche une barre de progression sur votre tableau de bord',
    foodCostAlertThreshold: "Seuil d'alerte coût matière (%)",
    foodCostAlertHint: "Affiche un avertissement quand le coût matière dépasse ce seuil",
    language: 'Langue', saveSettings: 'Sauvegarder', errorSaving: 'Erreur. Veuillez réessayer.',
    signIn: 'Connexion', signUp: 'Inscription', email: 'Email', password: 'Mot de passe',
    createAccount: 'Créer un compte', alreadyHaveAccount: 'Déjà un compte ?',
    dontHaveAccount: 'Pas encore de compte ?', pleaseWait: 'Veuillez patienter...',
    restaurantPL: 'P&L et Conseiller IA pour restaurants',
    welcomeTitle: 'Bienvenue sur WinProfit ! 👋', welcomeSub: 'Configurons votre restaurant en 2 minutes.',
    continueBtn: 'Continuer →', addFirstSale: 'Ajoutez votre première vente 📊',
    addFirstSaleSub: 'Saisissez les ventes du jour pour voir votre tableau de bord P&L.',
    saveAndContinue: 'Sauvegarder et continuer →', skipForNow: "Passer pour l'instant",
    skipSetup: 'Passer la configuration', allSet: 'Tout est prêt !',
    goToDashboard: 'Aller à mon tableau de bord →', stepOf: 'Étape', of: 'sur',
    freeTrial: 'Essai gratuit', daysLeft: 'jours restants',
    trialExpired: 'Votre essai gratuit est terminé. Choisissez un forfait.',
    trialActive: 'Il vous reste', daysLeftInTrial: "jours d'essai gratuit.",
    startFree: '30 jours gratuits. Sans carte bancaire.',
    monthly: 'Mensuel', yearly: 'Annuel', bestValue: 'Meilleur rapport qualité-prix',
    subscribeMonthly: "S'abonner mensuellement", subscribeYearly: "S'abonner annuellement",
    startFreeTrial: "Commencer l'essai gratuit", alreadyAccount: 'Déjà un compte ?',
    action: 'Action', primeCost: 'Coût prime', bevMix: 'Mix boissons',
    pleaseEnterDate: 'Veuillez entrer une date et au moins un montant de vente.',
    pleaseEnterDateAmount: 'Veuillez entrer une date et un montant.',
    pleaseEnterName: 'Veuillez entrer le nom du restaurant.',
    errorDelete: 'Supprimer cette entrée ?', errorDeleteExpense: 'Supprimer cette dépense ?',
    dailyRevenue: 'Revenus journaliers', monthTrend: 'Tendance 6 mois',
    lastPeriod: 'Période précédente', revenue: 'Revenus', ofWeeklyTargetPct: "de l'objectif hebdomadaire",
  },
  es: {
    dashboard: 'Panel', enterData: 'Ingresar datos', expenses: 'Gastos',
    inventory: 'Inventario', aiAdvisor: 'Asesor IA', settings: 'Configuración',
    signOut: 'Cerrar sesión', totalRevenue: 'Ingresos totales', foodCostPct: 'Costo de alimentos %',
    laborCostPct: 'Costo de mano de obra %', netProfit: 'Beneficio neto', daysTracked: 'días registrados',
    margin: 'Margen', target: 'Objetivo', pandlSummary: 'Resumen P&L',
    foodSales: 'Ventas de alimentos', beverageSales: 'Ventas de bebidas',
    totalRevenueLine: 'Ingresos totales', foodCost: 'Costo de alimentos',
    beverageCost: 'Costo de bebidas', labor: 'Mano de obra', rent: 'Alquiler',
    utilities: 'Servicios', other: 'Otros', netProfitLine: 'Beneficio neto',
    costBreakdown: 'Desglose de costos', avgCheck: 'Ticket promedio', totalCovers: 'Total comensales',
    downloadPL: 'Descargar informe P&L (Excel)', vsPrevMonth: 'vs Mes anterior',
    vsSameLastYear: 'vs Mismo mes año pasado', backToCurrentMonth: 'Volver al mes actual',
    noDataYet: 'Sin datos este mes.', goToEnterData: 'Ve a Ingresar datos para añadir tu primera venta.',
    weeklyTarget: 'Objetivo semanal', weeklyTargetReached: '¡Objetivo alcanzado esta semana!',
    toGo: 'restante', ofWeeklyTarget: 'del objetivo semanal',
    bestDay: 'Mejor día', worstDay: 'Peor día', busiestDay: 'Día más concurrido',
    covers: 'comensales', foodCostAlert: 'Alerta costo alimentos', threshold: 'umbral',
    aboveTarget: 'por encima del objetivo. Revisa tus compras e inventario.',
    approaching: 'Costo de alimentos acercándose al umbral',
    keepEye: 'Cerca del umbral de alerta. Vigila tus compras.',
    addUpdateSales: 'Agregar o actualizar ventas diarias', date: 'Fecha',
    coversGuests: 'Comensales', foodSalesAmt: 'Ventas alimentos ($)',
    beverageSalesAmt: 'Ventas bebidas ($)', saveEntry: 'Guardar', saving: 'Guardando...',
    saved: '¡Guardado!', thisMonth: 'Este mes', entries: 'entradas',
    noEntriesYet: 'Sin entradas este mes.', edit: 'Editar', saveChanges: 'Guardar cambios',
    cancel: 'Cancelar', downloadExcel: 'Descargar Excel', editEntry: 'Editar entrada',
    logExpense: 'Registrar gasto', category: 'Categoría', amount: 'Monto ($)',
    description: 'Descripción', saveExpense: 'Guardar gasto', noExpensesYet: 'Sin gastos registrados.',
    editExpense: 'Editar gasto', subcategory: 'Subcategoría', selectSubcategory: 'Seleccionar subcategoría...',
    catFoodCost: 'Costo alimentos', catBevCost: 'Costo bebidas', catLabor: 'Mano de obra',
    catRent: 'Alquiler', catUtilities: 'Servicios', catMarketing: 'Marketing',
    catMaintenance: 'Mantenimiento', catOther: 'Otros',
    meatSeafood: 'Carnes y Mariscos', produce: 'Frutas y Verduras', dairyEggs: 'Lácteos y Huevos',
    dryGoods: 'Despensa', otherFood: 'Otros alimentos', coffeeTea: 'Café y Té',
    softDrinks: 'Refrescos', alcohol: 'Alcohol', otherBev: 'Otras bebidas',
    inventoryCount: 'Conteo de inventario', openingInventory: 'Inventario inicial - inicio de mes',
    closingInventory: 'Inventario final - fin de mes', totalOpening: 'Total inicial', totalClosing: 'Total final',
    saveOpeningInventory: 'Guardar inventario inicial', saveClosingInventory: 'Guardar inventario final',
    realFoodCost: 'Cálculo costo real de alimentos', plusPurchases: 'Más compras (pestaña gastos)',
    minusClosing: 'Menos inventario final', inventoryVariance: 'Varianza de inventario',
    catMeatSeafood: 'Carnes y Mariscos', catProduce: 'Frutas y Verduras', catDairyEggs: 'Lácteos y Huevos',
    catDryGoods: 'Despensa', catBevCoffee: 'Bebidas - Café y Té', catBevSoft: 'Bebidas - Refrescos',
    catBevAlcohol: 'Bebidas - Alcohol', catBevOther: 'Otros',
    aiAdvisorTitle: 'Asesor IA impulsado por Claude',
    addDataFirst: 'Agrega datos de ventas para obtener consejos IA.',
    analyzing: 'Analizando tus números...', claudeReviewing: 'Claude está revisando tus datos.',
    readyToAnalyze: 'Listo para analizar', generateInsights: 'Generar consejos IA',
    regenerateInsights: 'Regenerar consejos', couldNotGenerate: 'No se pudo generar. Verifica tu clave API.',
    benchmarks: 'Referencias: costo alimentos 28-32% mano de obra 28-35% margen neto >10%',
    restaurantSettings: 'Configuración del restaurante', restaurantName: 'Nombre del restaurante',
    currency: 'Moneda', targetsAlerts: 'OBJETIVOS Y ALERTAS',
    weeklyRevenueTarget: 'Objetivo ingresos semanales ($)', weeklyTargetHint: 'Muestra una barra de progreso en tu panel',
    foodCostAlertThreshold: 'Umbral de alerta costo alimentos (%)', foodCostAlertHint: 'Muestra advertencia cuando el costo supere este número',
    language: 'Idioma', saveSettings: 'Guardar configuración', errorSaving: 'Error. Por favor intenta de nuevo.',
    signIn: 'Iniciar sesión', signUp: 'Registrarse', email: 'Correo', password: 'Contraseña',
    createAccount: 'Crear cuenta', alreadyHaveAccount: '¿Ya tienes cuenta?',
    dontHaveAccount: '¿No tienes cuenta?', pleaseWait: 'Por favor espera...',
    restaurantPL: 'P&L y Asesor IA para restaurantes',
    welcomeTitle: '¡Bienvenido a WinProfit! 👋', welcomeSub: 'Configuremos tu restaurante en 2 minutos.',
    continueBtn: 'Continuar →', addFirstSale: 'Agrega tu primera venta 📊',
    addFirstSaleSub: 'Ingresa las ventas de hoy para ver tu panel P&L.',
    saveAndContinue: 'Guardar y continuar →', skipForNow: 'Omitir por ahora',
    skipSetup: 'Omitir configuración', allSet: '¡Todo listo!', goToDashboard: 'Ir a mi panel →',
    stepOf: 'Paso', of: 'de', freeTrial: 'Prueba gratuita', daysLeft: 'días restantes',
    trialExpired: 'Tu prueba gratuita ha terminado. Elige un plan.',
    trialActive: 'Te quedan', daysLeftInTrial: 'días de prueba gratuita.',
    startFree: '30 días gratis. Sin tarjeta de crédito.',
    monthly: 'Mensual', yearly: 'Anual', bestValue: 'Mejor valor',
    subscribeMonthly: 'Suscribirse mensualmente', subscribeYearly: 'Suscribirse anualmente',
    startFreeTrial: 'Comenzar prueba gratuita', alreadyAccount: '¿Ya tienes cuenta?',
    action: 'Acción', primeCost: 'Costo primo', bevMix: 'Mix bebidas',
    pleaseEnterDate: 'Por favor ingresa una fecha y al menos un monto de venta.',
    pleaseEnterDateAmount: 'Por favor ingresa una fecha y un monto.',
    pleaseEnterName: 'Por favor ingresa el nombre del restaurante.',
    errorDelete: '¿Eliminar esta entrada?', errorDeleteExpense: '¿Eliminar este gasto?',
    dailyRevenue: 'Ingresos diarios', monthTrend: 'Tendencia 6 meses',
    lastPeriod: 'Período anterior', revenue: 'Ingresos', ofWeeklyTargetPct: 'del objetivo semanal',
  },
  km: {
    dashboard: 'ផ្ទាំងគ្រប់គ្រង', enterData: 'បញ្ចូលទិន្នន័យ', expenses: 'ការចំណាយ',
    inventory: 'ស្តុកទំនិញ', aiAdvisor: 'ទីប្រឹក្សា AI', settings: 'ការកំណត់',
    signOut: 'ចាកចេញ', totalRevenue: 'ចំណូលសរុប', foodCostPct: 'ចំណាយអាហារ %',
    laborCostPct: 'ចំណាយកម្លាំងពលកម្ម %', netProfit: 'ប្រាក់ចំណេញសុទ្ធ',
    daysTracked: 'ថ្ងៃដែលបានកត់ត្រា', margin: 'ម៉ាស៊ីន', target: 'គោលដៅ',
    pandlSummary: 'សង្ខេប P&L', foodSales: 'លក់អាហារ', beverageSales: 'លក់ភេសជ្ជៈ',
    totalRevenueLine: 'ចំណូលសរុប', foodCost: 'ចំណាយអាហារ', beverageCost: 'ចំណាយភេសជ្ជៈ',
    labor: 'កម្លាំងពលកម្ម', rent: 'ជួល', utilities: 'សេវាសាធារណៈ', other: 'ផ្សេងៗ',
    netProfitLine: 'ប្រាក់ចំណេញសុទ្ធ', costBreakdown: 'ការបែងចែកចំណាយ',
    avgCheck: 'វិក្កយបត្រមធ្យម', totalCovers: 'ចំនួនអតិថិជនសរុប',
    downloadPL: 'ទាញយករបាយការណ៍ P&L (Excel)', vsPrevMonth: 'ធៀបខែមុន',
    vsSameLastYear: 'ធៀបខែដូចគ្នាឆ្នាំមុន', backToCurrentMonth: 'ត្រឡប់ទៅខែបច្ចុប្បន្ន',
    noDataYet: 'មិនមានទិន្នន័យខែនេះ។', goToEnterData: 'ទៅបញ្ចូលទិន្នន័យដើម្បីបន្ថែមការលក់ដំបូង។',
    weeklyTarget: 'គោលដៅចំណូលប្រចាំសប្តាហ៍', weeklyTargetReached: 'គោលដៅសម្រេចសប្តាហ៍នេះ!',
    toGo: 'ទៀត', ofWeeklyTarget: 'នៃគោលដៅប្រចាំសប្តាហ៍',
    bestDay: 'ថ្ងៃល្អបំផុត', worstDay: 'ថ្ងៃអាក្រក់បំផុត', busiestDay: 'ថ្ងៃមមាញឹកបំផុត',
    covers: 'អតិថិជន', foodCostAlert: 'ការជូនដំណឹងចំណាយអាហារ', threshold: 'កម្រិត',
    aboveTarget: 'លើសគោលដៅ។ ពិនិត្យការទិញ និងស្តុក។',
    approaching: 'ចំណាយអាហារជិតដល់កម្រិត', keepEye: 'ជិតដល់កម្រិតជូនដំណឹង។',
    addUpdateSales: 'បន្ថែម ឬកែប្រែការលក់ប្រចាំថ្ងៃ', date: 'កាលបរិច្ឆេទ',
    coversGuests: 'ចំនួនអតិថិជន', foodSalesAmt: 'ការលក់អាហារ ($)',
    beverageSalesAmt: 'ការលក់ភេសជ្ជៈ ($)', saveEntry: 'រក្សាទុក', saving: 'កំពុងរក្សាទុក...',
    saved: 'បានរក្សាទុក!', thisMonth: 'ខែនេះ', entries: 'ធាតុ',
    noEntriesYet: 'មិនមានធាតុខែនេះ។', edit: 'កែប្រែ', saveChanges: 'រក្សាទុកការផ្លាស់ប្តូរ',
    cancel: 'បោះបង់', downloadExcel: 'ទាញយក Excel', editEntry: 'កែប្រែធាតុ',
    logExpense: 'ថតការចំណាយ', category: 'ប្រភេទ', amount: 'ចំនួនទឹកប្រាក់ ($)',
    description: 'ការពិពណ៌នា', saveExpense: 'រក្សាទុកការចំណាយ',
    noExpensesYet: 'មិនទាន់មានការចំណាយ។', editExpense: 'កែប្រែការចំណាយ',
    subcategory: 'ប្រភេទរង', selectSubcategory: 'ជ្រើសរើសប្រភេទរង...',
    catFoodCost: 'ចំណាយអាហារ', catBevCost: 'ចំណាយភេសជ្ជៈ', catLabor: 'កម្លាំងពលកម្ម',
    catRent: 'ជួល', catUtilities: 'សេវាសាធារណៈ', catMarketing: 'ទីផ្សារ',
    catMaintenance: 'ថែទាំ', catOther: 'ផ្សេងៗ',
    meatSeafood: 'សាច់ & អាហារសមុទ្រ', produce: 'បន្លែ & ផ្លែឈើ',
    dairyEggs: 'ផលិតផលទឹកដោះគោ & ស៊ុត', dryGoods: 'គ្រឿងទេស',
    otherFood: 'អាហារផ្សេងៗ', coffeeTea: 'កាហ្វេ & តែ',
    softDrinks: 'ភេសជ្ជៈគ្មានជាតិស្រវឹង', alcohol: 'គ្រឿងស្រវឹង', otherBev: 'ភេសជ្ជៈផ្សេងៗ',
    inventoryCount: 'រាប់ស្តុកទំនិញ', openingInventory: 'ស្តុកដំបូង - ដើមខែ',
    closingInventory: 'ស្តុកចុងក្រោយ - ចុងខែ', totalOpening: 'សរុបដំបូង', totalClosing: 'សរុបចុងក្រោយ',
    saveOpeningInventory: 'រក្សាទុកស្តុកដំបូង', saveClosingInventory: 'រក្សាទុកស្តុកចុងក្រោយ',
    realFoodCost: 'គណនាចំណាយអាហារពិតប្រាកដ', plusPurchases: 'បូកការទិញ (ផ្ទាំងចំណាយ)',
    minusClosing: 'ដក ស្តុកចុងក្រោយ', inventoryVariance: 'ភាពខុសគ្នានៃស្តុក',
    catMeatSeafood: 'សាច់ និងអាហារសមុទ្រ', catProduce: 'បន្លែ និងផ្លែឈើ',
    catDairyEggs: 'ផលិតផលទឹកដោះគោ និងស៊ុត', catDryGoods: 'គ្រឿងទេស',
    catBevCoffee: 'ភេសជ្ជៈ - កាហ្វេ និងតែ', catBevSoft: 'ភេសជ្ជៈ - គ្មានជាតិស្រវឹង',
    catBevAlcohol: 'ភេសជ្ជៈ - គ្រឿងស្រវឹង', catBevOther: 'ផ្សេងៗ',
    aiAdvisorTitle: 'ទីប្រឹក្សា AI ដំណើរការដោយ Claude',
    addDataFirst: 'បន្ថែមទិន្នន័យការលក់ ដើម្បីទទួលបានដំបូន្មាន AI។',
    analyzing: 'កំពុងវិភាគ...', claudeReviewing: 'Claude កំពុងពិនិត្យ។',
    readyToAnalyze: 'រួចរាល់', generateInsights: 'បង្កើតដំបូន្មាន AI',
    regenerateInsights: 'បង្កើតឡើងវិញ', couldNotGenerate: 'មិនអាចបង្កើតបាន។',
    benchmarks: 'ស្តង់ដារ: ចំណាយអាហារ 28-32% ពលកម្ម 28-35% ចំណេញ >10%',
    restaurantSettings: 'ការកំណត់ភោជនីយដ្ឋាន', restaurantName: 'ឈ្មោះភោជនីយដ្ឋាន',
    currency: 'រូបិយប័ណ្ណ', targetsAlerts: 'គោលដៅ និងការជូនដំណឹង',
    weeklyRevenueTarget: 'គោលដៅចំណូលប្រចាំសប្តាហ៍ ($)',
    weeklyTargetHint: 'បង្ហាញរបាររីកចម្រើននៅលើផ្ទាំងគ្រប់គ្រង',
    foodCostAlertThreshold: 'កម្រិតជូនដំណឹងចំណាយអាហារ (%)',
    foodCostAlertHint: 'បង្ហាញការព្រមាននៅពេលចំណាយអាហារលើសកម្រិត',
    language: 'ភាសា', saveSettings: 'រក្សាទុកការកំណត់', errorSaving: 'មានកំហុស។ សូមព្យាយាមម្ដងទៀត។',
    signIn: 'ចូល', signUp: 'ចុះឈ្មោះ', email: 'អ៊ីមែល', password: 'ពាក្យសម្ងាត់',
    createAccount: 'បង្កើតគណនី', alreadyHaveAccount: 'មានគណនីហើយ?',
    dontHaveAccount: 'មិនទាន់មានគណនី?', pleaseWait: 'សូមរង់ចាំ...',
    restaurantPL: 'P&L និងទីប្រឹក្សា AI សម្រាប់ភោជនីយដ្ឋាន',
    welcomeTitle: 'សូមស្វាគមន៍មក WinProfit! 👋', welcomeSub: 'តោះរៀបចំភោជនីយដ្ឋានរបស់អ្នកក្នុង 2 នាទី។',
    continueBtn: 'បន្ត →', addFirstSale: 'បន្ថែមការលក់ដំបូង 📊',
    addFirstSaleSub: 'បញ្ចូលការលក់ថ្ងៃនេះ ដើម្បីមើលផ្ទាំង P&L។',
    saveAndContinue: 'រក្សាទុក និងបន្ត →', skipForNow: 'រំលងសម្រាប់ពេលនេះ',
    skipSetup: 'រំលងការរៀបចំ', allSet: 'រួចរាល់ហើយ!', goToDashboard: 'ទៅផ្ទាំងគ្រប់គ្រង →',
    stepOf: 'ជំហាន', of: 'នៃ', freeTrial: 'សាកល្បងឥតគិតថ្លៃ', daysLeft: 'ថ្ងៃនៅសល់',
    trialExpired: 'ការសាកល្បងរបស់អ្នកបានផុតកំណត់។', trialActive: 'អ្នកនៅសល់', daysLeftInTrial: 'ថ្ងៃសាកល្បង។',
    startFree: 'ឥតគិតថ្លៃ 30 ថ្ងៃ។ មិនត្រូវការកាតឥណទាន។',
    monthly: 'ប្រចាំខែ', yearly: 'ប្រចាំឆ្នាំ', bestValue: 'តម្លៃល្អបំផុត',
    subscribeMonthly: 'ជាវប្រចាំខែ', subscribeYearly: 'ជាវប្រចាំឆ្នាំ',
    startFreeTrial: 'ចាប់ផ្តើមសាកល្បង', alreadyAccount: 'មានគណនីហើយ?',
    action: 'សកម្មភាព', primeCost: 'ចំណាយចម្បង', bevMix: 'ចំណែកភេសជ្ជៈ',
    pleaseEnterDate: 'សូមបញ្ចូលកាលបរិច្ឆេទ និងចំនួនលក់យ៉ាងតិចមួយ។',
    pleaseEnterDateAmount: 'សូមបញ្ចូលកាលបរិច្ឆេទ និងចំនួន។',
    pleaseEnterName: 'សូមបញ្ចូលឈ្មោះភោជនីយដ្ឋាន។',
    errorDelete: 'លុបធាតុនេះ?', errorDeleteExpense: 'លុបការចំណាយនេះ?',
    dailyRevenue: 'ចំណូលប្រចាំថ្ងៃ', monthTrend: 'និន្នាការ 6 ខែ',
    lastPeriod: 'រយៈពេលមុន', revenue: 'ចំណូល', ofWeeklyTargetPct: 'នៃគោលដៅប្រចាំសប្តាហ៍',
  },
  zh: {
    dashboard: '仪表板', enterData: '输入数据', expenses: '费用', inventory: '库存',
    aiAdvisor: 'AI顾问', settings: '设置', signOut: '退出', totalRevenue: '总收入',
    foodCostPct: '食材成本%', laborCostPct: '人工成本%', netProfit: '净利润',
    daysTracked: '已记录天数', margin: '利润率', target: '目标', pandlSummary: '损益摘要',
    foodSales: '餐食销售', beverageSales: '饮料销售', totalRevenueLine: '总收入',
    foodCost: '食材成本', beverageCost: '饮料成本', labor: '人工', rent: '租金',
    utilities: '水电费', other: '其他', netProfitLine: '净利润',
    costBreakdown: '成本分析', avgCheck: '人均消费', totalCovers: '总客数',
    downloadPL: '下载损益报告（Excel）', vsPrevMonth: '对比上月',
    vsSameLastYear: '对比去年同月', backToCurrentMonth: '返回本月',
    noDataYet: '本月暂无数据。', goToEnterData: '前往输入数据添加第一笔销售。',
    weeklyTarget: '每周营收目标', weeklyTargetReached: '本周目标已达成！',
    toGo: '待完成', ofWeeklyTarget: '每周目标完成率',
    bestDay: '最佳日', worstDay: '最差日', busiestDay: '最忙日', covers: '位客人',
    foodCostAlert: '食材成本预警', threshold: '阈值', aboveTarget: '超过目标。请检查采购和库存。',
    approaching: '食材成本接近阈值', keepEye: '接近预警阈值，请关注采购。',
    addUpdateSales: '添加或更新每日销售', date: '日期', coversGuests: '客数',
    foodSalesAmt: '餐食销售（$）', beverageSalesAmt: '饮料销售（$）',
    saveEntry: '保存', saving: '保存中...', saved: '已保存！', thisMonth: '本月',
    entries: '条记录', noEntriesYet: '本月暂无记录。', edit: '编辑', saveChanges: '保存更改',
    cancel: '取消', downloadExcel: '下载Excel', editEntry: '编辑记录',
    logExpense: '记录费用', category: '类别', amount: '金额（$）', description: '描述',
    saveExpense: '保存费用', noExpensesYet: '暂无费用记录。', editExpense: '编辑费用',
    subcategory: '子类别', selectSubcategory: '选择子类别...',
    catFoodCost: '食材成本', catBevCost: '饮料成本', catLabor: '人工', catRent: '租金',
    catUtilities: '水电费', catMarketing: '营销', catMaintenance: '维修', catOther: '其他',
    meatSeafood: '肉类和海鲜', produce: '蔬菜水果', dairyEggs: '乳制品和鸡蛋',
    dryGoods: '干货', otherFood: '其他食品', coffeeTea: '咖啡和茶',
    softDrinks: '软饮料', alcohol: '酒精饮料', otherBev: '其他饮料',
    inventoryCount: '库存盘点', openingInventory: '期初库存 - 月初', closingInventory: '期末库存 - 月末',
    totalOpening: '期初合计', totalClosing: '期末合计',
    saveOpeningInventory: '保存期初库存', saveClosingInventory: '保存期末库存',
    realFoodCost: '实际食材成本计算', plusPurchases: '加采购（费用标签）',
    minusClosing: '减期末库存', inventoryVariance: '库存差异',
    catMeatSeafood: '肉类和海鲜', catProduce: '蔬菜水果', catDairyEggs: '乳制品和鸡蛋',
    catDryGoods: '干货', catBevCoffee: '饮料 - 咖啡和茶', catBevSoft: '饮料 - 软饮料',
    catBevAlcohol: '饮料 - 酒精', catBevOther: '其他',
    aiAdvisorTitle: 'AI顾问（由Claude驱动）', addDataFirst: '请先添加销售数据以获取AI建议。',
    analyzing: '分析中...', claudeReviewing: 'Claude正在审查。', readyToAnalyze: '准备分析',
    generateInsights: '生成AI建议', regenerateInsights: '重新生成建议',
    couldNotGenerate: '无法生成建议。请检查API密钥。',
    benchmarks: '基准：食材成本28-32% 人工28-35% 净利润>10%',
    restaurantSettings: '餐厅设置', restaurantName: '餐厅名称', currency: '货币',
    targetsAlerts: '目标和预警', weeklyRevenueTarget: '每周营收目标（$）',
    weeklyTargetHint: '在仪表板上显示进度条', foodCostAlertThreshold: '食材成本预警阈值（%）',
    foodCostAlertHint: '当食材成本超过此值时显示警告',
    language: '语言', saveSettings: '保存设置', errorSaving: '保存失败，请重试。',
    signIn: '登录', signUp: '注册', email: '邮箱', password: '密码',
    createAccount: '创建账户', alreadyHaveAccount: '已有账户？', dontHaveAccount: '没有账户？',
    pleaseWait: '请稍候...', restaurantPL: '餐厅损益和AI顾问',
    welcomeTitle: '欢迎来到WinProfit！👋', welcomeSub: '让我们在2分钟内设置您的餐厅。',
    continueBtn: '继续 →', addFirstSale: '添加第一笔销售 📊',
    addFirstSaleSub: '输入今天的销售额以查看损益仪表板。',
    saveAndContinue: '保存并继续 →', skipForNow: '暂时跳过',
    skipSetup: '跳过设置', allSet: '一切就绪！', goToDashboard: '前往仪表板 →',
    stepOf: '第', of: '步，共', freeTrial: '免费试用', daysLeft: '天剩余',
    trialExpired: '您的免费试用已结束。请选择套餐。',
    trialActive: '您还有', daysLeftInTrial: '天免费试用。',
    startFree: '免费30天。无需信用卡。', monthly: '月付', yearly: '年付', bestValue: '最优惠',
    subscribeMonthly: '按月订阅', subscribeYearly: '按年订阅',
    startFreeTrial: '开始免费试用', alreadyAccount: '已有账户？',
    action: '操作', primeCost: '主要成本', bevMix: '饮料占比',
    pleaseEnterDate: '请输入日期和至少一个销售金额。', pleaseEnterDateAmount: '请输入日期和金额。',
    pleaseEnterName: '请输入餐厅名称。', errorDelete: '删除此记录？', errorDeleteExpense: '删除此费用？',
    dailyRevenue: '每日收入', monthTrend: '6个月收入趋势',
    lastPeriod: '上期', revenue: '收入', ofWeeklyTargetPct: '每周目标完成率',
  },
  'zh-TW': {
    dashboard: '儀表板', enterData: '輸入數據', expenses: '費用', inventory: '庫存',
    aiAdvisor: 'AI顧問', settings: '設定', signOut: '登出', totalRevenue: '總收入',
    foodCostPct: '食材成本%', laborCostPct: '人工成本%', netProfit: '淨利潤',
    daysTracked: '已記錄天數', margin: '利潤率', target: '目標', pandlSummary: '損益摘要',
    foodSales: '餐食銷售', beverageSales: '飲料銷售', totalRevenueLine: '總收入',
    foodCost: '食材成本', beverageCost: '飲料成本', labor: '人工', rent: '租金',
    utilities: '水電費', other: '其他', netProfitLine: '淨利潤',
    costBreakdown: '成本分析', avgCheck: '人均消費', totalCovers: '總客數',
    downloadPL: '下載損益報告（Excel）', vsPrevMonth: '對比上月',
    vsSameLastYear: '對比去年同月', backToCurrentMonth: '返回本月',
    noDataYet: '本月暫無數據。', goToEnterData: '前往輸入數據添加第一筆銷售。',
    weeklyTarget: '每週營收目標', weeklyTargetReached: '本週目標已達成！',
    toGo: '待完成', ofWeeklyTarget: '每週目標達成率',
    bestDay: '最佳日', worstDay: '最差日', busiestDay: '最忙日', covers: '位客人',
    foodCostAlert: '食材成本預警', threshold: '閾值', aboveTarget: '超過目標。請檢查採購和庫存。',
    approaching: '食材成本接近閾值', keepEye: '接近預警閾值，請關注採購。',
    addUpdateSales: '新增或更新每日銷售', date: '日期', coversGuests: '客數',
    foodSalesAmt: '餐食銷售（$）', beverageSalesAmt: '飲料銷售（$）',
    saveEntry: '儲存', saving: '儲存中...', saved: '已儲存！', thisMonth: '本月',
    entries: '筆記錄', noEntriesYet: '本月暫無記錄。', edit: '編輯', saveChanges: '儲存變更',
    cancel: '取消', downloadExcel: '下載Excel', editEntry: '編輯記錄',
    logExpense: '記錄費用', category: '類別', amount: '金額（$）', description: '描述',
    saveExpense: '儲存費用', noExpensesYet: '暫無費用記錄。', editExpense: '編輯費用',
    subcategory: '子類別', selectSubcategory: '選擇子類別...',
    catFoodCost: '食材成本', catBevCost: '飲料成本', catLabor: '人工', catRent: '租金',
    catUtilities: '水電費', catMarketing: '行銷', catMaintenance: '維修', catOther: '其他',
    meatSeafood: '肉類和海鮮', produce: '蔬菜水果', dairyEggs: '乳製品和雞蛋',
    dryGoods: '乾貨', otherFood: '其他食品', coffeeTea: '咖啡和茶',
    softDrinks: '軟飲料', alcohol: '酒精飲料', otherBev: '其他飲料',
    inventoryCount: '庫存盤點', openingInventory: '期初庫存 - 月初', closingInventory: '期末庫存 - 月末',
    totalOpening: '期初合計', totalClosing: '期末合計',
    saveOpeningInventory: '儲存期初庫存', saveClosingInventory: '儲存期末庫存',
    realFoodCost: '實際食材成本計算', plusPurchases: '加採購（費用標籤）',
    minusClosing: '減期末庫存', inventoryVariance: '庫存差異',
    catMeatSeafood: '肉類和海鮮', catProduce: '蔬菜水果', catDairyEggs: '乳製品和雞蛋',
    catDryGoods: '乾貨', catBevCoffee: '飲料 - 咖啡和茶', catBevSoft: '飲料 - 軟飲料',
    catBevAlcohol: '飲料 - 酒精', catBevOther: '其他',
    aiAdvisorTitle: 'AI顧問（由Claude驅動）', addDataFirst: '請先添加銷售數據以獲取AI建議。',
    analyzing: '分析中...', claudeReviewing: 'Claude正在審查。', readyToAnalyze: '準備分析',
    generateInsights: '生成AI建議', regenerateInsights: '重新生成建議',
    couldNotGenerate: '無法生成建議。請檢查API金鑰。',
    benchmarks: '基準：食材成本28-32% 人工28-35% 淨利潤>10%',
    restaurantSettings: '餐廳設定', restaurantName: '餐廳名稱', currency: '貨幣',
    targetsAlerts: '目標和預警', weeklyRevenueTarget: '每週營收目標（$）',
    weeklyTargetHint: '在儀表板上顯示進度條', foodCostAlertThreshold: '食材成本預警閾值（%）',
    foodCostAlertHint: '當食材成本超過此值時顯示警告',
    language: '語言', saveSettings: '儲存設定', errorSaving: '儲存失敗，請重試。',
    signIn: '登入', signUp: '註冊', email: '電郵', password: '密碼',
    createAccount: '建立帳戶', alreadyHaveAccount: '已有帳戶？', dontHaveAccount: '沒有帳戶？',
    pleaseWait: '請稍候...', restaurantPL: '餐廳損益和AI顧問',
    welcomeTitle: '歡迎來到WinProfit！👋', welcomeSub: '讓我們在2分鐘內設定您的餐廳。',
    continueBtn: '繼續 →', addFirstSale: '添加第一筆銷售 📊',
    addFirstSaleSub: '輸入今天的銷售額以查看損益儀表板。',
    saveAndContinue: '儲存並繼續 →', skipForNow: '暫時跳過',
    skipSetup: '跳過設定', allSet: '一切就緒！', goToDashboard: '前往儀表板 →',
    stepOf: '第', of: '步，共', freeTrial: '免費試用', daysLeft: '天剩餘',
    trialExpired: '您的免費試用已結束。請選擇方案。',
    trialActive: '您還有', daysLeftInTrial: '天免費試用。',
    startFree: '免費30天。無需信用卡。', monthly: '月付', yearly: '年付', bestValue: '最優惠',
    subscribeMonthly: '按月訂閱', subscribeYearly: '按年訂閱',
    startFreeTrial: '開始免費試用', alreadyAccount: '已有帳戶？',
    action: '操作', primeCost: '主要成本', bevMix: '飲料占比',
    pleaseEnterDate: '請輸入日期和至少一個銷售金額。', pleaseEnterDateAmount: '請輸入日期和金額。',
    pleaseEnterName: '請輸入餐廳名稱。', errorDelete: '刪除此記錄？', errorDeleteExpense: '刪除此費用？',
    dailyRevenue: '每日收入', monthTrend: '6個月收入趨勢',
    lastPeriod: '上期', revenue: '收入', ofWeeklyTargetPct: '每週目標達成率',
  },
  th: {
    dashboard: 'แดชบอร์ด', enterData: 'ป้อนข้อมูล', expenses: 'ค่าใช้จ่าย',
    inventory: 'สินค้าคงคลัง', aiAdvisor: 'ที่ปรึกษา AI', settings: 'การตั้งค่า',
    signOut: 'ออกจากระบบ', totalRevenue: 'รายได้รวม', foodCostPct: 'ต้นทุนอาหาร %',
    laborCostPct: 'ต้นทุนแรงงาน %', netProfit: 'กำไรสุทธิ', daysTracked: 'วันที่บันทึก',
    margin: 'มาร์จิ้น', target: 'เป้าหมาย', pandlSummary: 'สรุป P&L',
    foodSales: 'ยอดขายอาหาร', beverageSales: 'ยอดขายเครื่องดื่ม', totalRevenueLine: 'รายได้รวม',
    foodCost: 'ต้นทุนอาหาร', beverageCost: 'ต้นทุนเครื่องดื่ม', labor: 'แรงงาน',
    rent: 'ค่าเช่า', utilities: 'ค่าสาธารณูปโภค', other: 'อื่นๆ', netProfitLine: 'กำไรสุทธิ',
    costBreakdown: 'การแบ่งต้นทุน', avgCheck: 'ค่าเฉลี่ยต่อคน', totalCovers: 'ลูกค้ารวม',
    downloadPL: 'ดาวน์โหลดรายงาน P&L (Excel)', vsPrevMonth: 'เทียบเดือนก่อน',
    vsSameLastYear: 'เทียบเดือนเดียวกันปีก่อน', backToCurrentMonth: 'กลับเดือนปัจจุบัน',
    noDataYet: 'ยังไม่มีข้อมูลเดือนนี้', goToEnterData: 'ไปที่ป้อนข้อมูลเพื่อเพิ่มยอดขายแรก',
    weeklyTarget: 'เป้าหมายรายได้รายสัปดาห์', weeklyTargetReached: 'บรรลุเป้าหมายสัปดาห์นี้!',
    toGo: 'เหลืออีก', ofWeeklyTarget: 'ของเป้าหมายรายสัปดาห์',
    bestDay: 'วันที่ดีที่สุด', worstDay: 'วันที่แย่ที่สุด', busiestDay: 'วันที่ยุ่งที่สุด',
    covers: 'ลูกค้า', foodCostAlert: 'แจ้งเตือนต้นทุนอาหาร', threshold: 'เกณฑ์',
    aboveTarget: 'เกินเป้าหมาย ตรวจสอบการจัดซื้อและสินค้าคงคลัง',
    approaching: 'ต้นทุนอาหารใกล้ถึงเกณฑ์', keepEye: 'ใกล้ถึงเกณฑ์แจ้งเตือน ดูแลการจัดซื้อ',
    addUpdateSales: 'เพิ่มหรืออัพเดตยอดขายรายวัน', date: 'วันที่', coversGuests: 'จำนวนลูกค้า',
    foodSalesAmt: 'ยอดขายอาหาร ($)', beverageSalesAmt: 'ยอดขายเครื่องดื่ม ($)',
    saveEntry: 'บันทึก', saving: 'กำลังบันทึก...', saved: 'บันทึกแล้ว!', thisMonth: 'เดือนนี้',
    entries: 'รายการ', noEntriesYet: 'ยังไม่มีรายการเดือนนี้', edit: 'แก้ไข',
    saveChanges: 'บันทึกการเปลี่ยนแปลง', cancel: 'ยกเลิก', downloadExcel: 'ดาวน์โหลด Excel',
    editEntry: 'แก้ไขรายการ', logExpense: 'บันทึกค่าใช้จ่าย', category: 'หมวดหมู่',
    amount: 'จำนวน ($)', description: 'คำอธิบาย', saveExpense: 'บันทึกค่าใช้จ่าย',
    noExpensesYet: 'ยังไม่มีค่าใช้จ่าย', editExpense: 'แก้ไขค่าใช้จ่าย',
    subcategory: 'หมวดหมู่ย่อย', selectSubcategory: 'เลือกหมวดหมู่ย่อย...',
    catFoodCost: 'ต้นทุนอาหาร', catBevCost: 'ต้นทุนเครื่องดื่ม', catLabor: 'แรงงาน',
    catRent: 'ค่าเช่า', catUtilities: 'สาธารณูปโภค', catMarketing: 'การตลาด',
    catMaintenance: 'ซ่อมบำรุง', catOther: 'อื่นๆ',
    meatSeafood: 'เนื้อสัตว์และอาหารทะเล', produce: 'ผักและผลไม้', dairyEggs: 'นมและไข่',
    dryGoods: 'วัตถุดิบแห้ง', otherFood: 'อาหารอื่นๆ', coffeeTea: 'กาแฟและชา',
    softDrinks: 'น้ำอัดลม', alcohol: 'เครื่องดื่มแอลกอฮอล์', otherBev: 'เครื่องดื่มอื่นๆ',
    inventoryCount: 'นับสินค้าคงคลัง', openingInventory: 'สินค้าต้นเดือน',
    closingInventory: 'สินค้าปลายเดือน', totalOpening: 'รวมต้นเดือน', totalClosing: 'รวมปลายเดือน',
    saveOpeningInventory: 'บันทึกสินค้าต้นเดือน', saveClosingInventory: 'บันทึกสินค้าปลายเดือน',
    realFoodCost: 'คำนวณต้นทุนอาหารจริง', plusPurchases: 'บวกการจัดซื้อ',
    minusClosing: 'ลบสินค้าปลายเดือน', inventoryVariance: 'ความแตกต่างสินค้า',
    catMeatSeafood: 'เนื้อสัตว์และอาหารทะเล', catProduce: 'ผักและผลไม้',
    catDairyEggs: 'นมและไข่', catDryGoods: 'วัตถุดิบแห้ง',
    catBevCoffee: 'เครื่องดื่ม - กาแฟและชา', catBevSoft: 'เครื่องดื่ม - น้ำอัดลม',
    catBevAlcohol: 'เครื่องดื่ม - แอลกอฮอล์', catBevOther: 'อื่นๆ',
    aiAdvisorTitle: 'ที่ปรึกษา AI ขับเคลื่อนโดย Claude',
    addDataFirst: 'เพิ่มข้อมูลยอดขายก่อนเพื่อรับคำแนะนำ AI',
    analyzing: 'กำลังวิเคราะห์...', claudeReviewing: 'Claude กำลังตรวจสอบ',
    readyToAnalyze: 'พร้อมวิเคราะห์', generateInsights: 'สร้างคำแนะนำ AI',
    regenerateInsights: 'สร้างคำแนะนำใหม่', couldNotGenerate: 'ไม่สามารถสร้างได้ ตรวจสอบ API key',
    benchmarks: 'มาตรฐาน: ต้นทุนอาหาร 28-32% แรงงาน 28-35% กำไร >10%',
    restaurantSettings: 'ตั้งค่าร้านอาหาร', restaurantName: 'ชื่อร้านอาหาร', currency: 'สกุลเงิน',
    targetsAlerts: 'เป้าหมายและการแจ้งเตือน', weeklyRevenueTarget: 'เป้าหมายรายได้รายสัปดาห์ ($)',
    weeklyTargetHint: 'แสดงแถบความคืบหน้าบนแดชบอร์ด',
    foodCostAlertThreshold: 'เกณฑ์แจ้งเตือนต้นทุนอาหาร (%)',
    foodCostAlertHint: 'แสดงคำเตือนเมื่อต้นทุนอาหารเกินเกณฑ์',
    language: 'ภาษา', saveSettings: 'บันทึกการตั้งค่า', errorSaving: 'เกิดข้อผิดพลาด ลองอีกครั้ง',
    signIn: 'เข้าสู่ระบบ', signUp: 'สมัครสมาชิก', email: 'อีเมล', password: 'รหัสผ่าน',
    createAccount: 'สร้างบัญชี', alreadyHaveAccount: 'มีบัญชีแล้ว?', dontHaveAccount: 'ยังไม่มีบัญชี?',
    pleaseWait: 'กรุณารอ...', restaurantPL: 'P&L และที่ปรึกษา AI สำหรับร้านอาหาร',
    welcomeTitle: 'ยินดีต้อนรับสู่ WinProfit! 👋', welcomeSub: 'ตั้งค่าร้านอาหารของคุณใน 2 นาที',
    continueBtn: 'ต่อไป →', addFirstSale: 'เพิ่มยอดขายแรก 📊',
    addFirstSaleSub: 'ป้อนยอดขายวันนี้เพื่อดูแดชบอร์ด P&L',
    saveAndContinue: 'บันทึกและต่อไป →', skipForNow: 'ข้ามสำหรับตอนนี้',
    skipSetup: 'ข้ามการตั้งค่า', allSet: 'เรียบร้อยแล้ว!', goToDashboard: 'ไปที่แดชบอร์ด →',
    stepOf: 'ขั้นตอนที่', of: 'จาก', freeTrial: 'ทดลองใช้ฟรี', daysLeft: 'วันที่เหลือ',
    trialExpired: 'การทดลองใช้ฟรีสิ้นสุดแล้ว เลือกแผน',
    trialActive: 'คุณมีเวลาอีก', daysLeftInTrial: 'วันในการทดลองใช้',
    startFree: 'ฟรี 30 วัน ไม่ต้องใช้บัตรเครดิต',
    monthly: 'รายเดือน', yearly: 'รายปี', bestValue: 'คุ้มค่าที่สุด',
    subscribeMonthly: 'สมัครรายเดือน', subscribeYearly: 'สมัครรายปี',
    startFreeTrial: 'เริ่มทดลองใช้ฟรี', alreadyAccount: 'มีบัญชีแล้ว?',
    action: 'การดำเนินการ', primeCost: 'ต้นทุนหลัก', bevMix: 'สัดส่วนเครื่องดื่ม',
    pleaseEnterDate: 'กรุณาป้อนวันที่และยอดขายอย่างน้อยหนึ่งรายการ',
    pleaseEnterDateAmount: 'กรุณาป้อนวันที่และจำนวน', pleaseEnterName: 'กรุณาป้อนชื่อร้านอาหาร',
    errorDelete: 'ลบรายการนี้?', errorDeleteExpense: 'ลบค่าใช้จ่ายนี้?',
    dailyRevenue: 'รายได้รายวัน', monthTrend: 'แนวโน้ม 6 เดือน',
    lastPeriod: 'ช่วงก่อน', revenue: 'รายได้', ofWeeklyTargetPct: 'ของเป้าหมายรายสัปดาห์',
  },
  ru: {
    dashboard: 'Панель управления', enterData: 'Ввод данных', expenses: 'Расходы',
    inventory: 'Инвентарь', aiAdvisor: 'AI-советник', settings: 'Настройки',
    signOut: 'Выйти', totalRevenue: 'Общая выручка', foodCostPct: 'Себестоимость еды %',
    laborCostPct: 'Затраты на персонал %', netProfit: 'Чистая прибыль',
    daysTracked: 'дней отслежено', margin: 'Маржа', target: 'Цель', pandlSummary: 'Отчёт P&L',
    foodSales: 'Продажи еды', beverageSales: 'Продажи напитков', totalRevenueLine: 'Общая выручка',
    foodCost: 'Себестоимость еды', beverageCost: 'Себестоимость напитков', labor: 'Персонал',
    rent: 'Аренда', utilities: 'Коммунальные услуги', other: 'Прочее', netProfitLine: 'Чистая прибыль',
    costBreakdown: 'Структура затрат', avgCheck: 'Средний чек', totalCovers: 'Всего гостей',
    downloadPL: 'Скачать отчёт P&L (Excel)', vsPrevMonth: 'vs Прошлый месяц',
    vsSameLastYear: 'vs Тот же месяц прошлого года', backToCurrentMonth: 'Вернуться к текущему месяцу',
    noDataYet: 'Нет данных за этот месяц.', goToEnterData: 'Перейдите в Ввод данных для добавления продаж.',
    weeklyTarget: 'Еженедельная цель выручки', weeklyTargetReached: 'Цель на эту неделю достигнута!',
    toGo: 'осталось', ofWeeklyTarget: 'от еженедельной цели',
    bestDay: 'Лучший день', worstDay: 'Худший день', busiestDay: 'Самый загруженный день',
    covers: 'гостей', foodCostAlert: 'Предупреждение о себестоимости', threshold: 'порог',
    aboveTarget: 'выше цели. Проверьте закупки и инвентарь.',
    approaching: 'Себестоимость приближается к порогу', keepEye: 'Близко к порогу. Следите за закупками.',
    addUpdateSales: 'Добавить или обновить ежедневные продажи', date: 'Дата',
    coversGuests: 'Количество гостей', foodSalesAmt: 'Продажи еды ($)',
    beverageSalesAmt: 'Продажи напитков ($)', saveEntry: 'Сохранить', saving: 'Сохранение...',
    saved: 'Сохранено!', thisMonth: 'Этот месяц', entries: 'записей',
    noEntriesYet: 'Нет записей за этот месяц.', edit: 'Редактировать',
    saveChanges: 'Сохранить изменения', cancel: 'Отмена', downloadExcel: 'Скачать Excel',
    editEntry: 'Редактировать запись', logExpense: 'Записать расход', category: 'Категория',
    amount: 'Сумма ($)', description: 'Описание', saveExpense: 'Сохранить расход',
    noExpensesYet: 'Расходы не добавлены.', editExpense: 'Редактировать расход',
    subcategory: 'Подкатегория', selectSubcategory: 'Выберите подкатегорию...',
    catFoodCost: 'Себестоимость еды', catBevCost: 'Себестоимость напитков', catLabor: 'Персонал',
    catRent: 'Аренда', catUtilities: 'Коммунальные', catMarketing: 'Маркетинг',
    catMaintenance: 'Обслуживание', catOther: 'Прочее',
    meatSeafood: 'Мясо и морепродукты', produce: 'Овощи и фрукты', dairyEggs: 'Молочные и яйца',
    dryGoods: 'Сухие товары', otherFood: 'Другие продукты', coffeeTea: 'Кофе и чай',
    softDrinks: 'Безалкогольные напитки', alcohol: 'Алкоголь', otherBev: 'Другие напитки',
    inventoryCount: 'Инвентаризация', openingInventory: 'Начальный остаток - начало месяца',
    closingInventory: 'Конечный остаток - конец месяца', totalOpening: 'Итого начало',
    totalClosing: 'Итого конец', saveOpeningInventory: 'Сохранить начальный остаток',
    saveClosingInventory: 'Сохранить конечный остаток',
    realFoodCost: 'Расчёт реальной себестоимости', plusPurchases: 'Плюс закупки',
    minusClosing: 'Минус конечный остаток', inventoryVariance: 'Разница инвентаря',
    catMeatSeafood: 'Мясо и морепродукты', catProduce: 'Овощи и фрукты',
    catDairyEggs: 'Молочные и яйца', catDryGoods: 'Сухие товары',
    catBevCoffee: 'Напитки - Кофе и чай', catBevSoft: 'Напитки - Безалкогольные',
    catBevAlcohol: 'Напитки - Алкоголь', catBevOther: 'Прочее',
    aiAdvisorTitle: 'AI-советник на базе Claude', addDataFirst: 'Добавьте данные о продажах для советов AI.',
    analyzing: 'Анализируем...', claudeReviewing: 'Claude анализирует.', readyToAnalyze: 'Готово к анализу',
    generateInsights: 'Создать советы AI', regenerateInsights: 'Создать советы снова',
    couldNotGenerate: 'Не удалось создать. Проверьте API ключ.',
    benchmarks: 'Стандарты: себестоимость 28-32% персонал 28-35% прибыль >10%',
    restaurantSettings: 'Настройки ресторана', restaurantName: 'Название ресторана',
    currency: 'Валюта', targetsAlerts: 'ЦЕЛИ И ОПОВЕЩЕНИЯ',
    weeklyRevenueTarget: 'Еженедельная цель выручки ($)', weeklyTargetHint: 'Показывает прогресс-бар на панели',
    foodCostAlertThreshold: 'Порог предупреждения о себестоимости (%)',
    foodCostAlertHint: 'Показывает предупреждение при превышении порога',
    language: 'Язык', saveSettings: 'Сохранить настройки', errorSaving: 'Ошибка. Попробуйте снова.',
    signIn: 'Войти', signUp: 'Зарегистрироваться', email: 'Email', password: 'Пароль',
    createAccount: 'Создать аккаунт', alreadyHaveAccount: 'Уже есть аккаунт?',
    dontHaveAccount: 'Нет аккаунта?', pleaseWait: 'Подождите...',
    restaurantPL: 'P&L и AI-советник для ресторанов',
    welcomeTitle: 'Добро пожаловать в WinProfit! 👋', welcomeSub: 'Настроим ваш ресторан за 2 минуты.',
    continueBtn: 'Продолжить →', addFirstSale: 'Добавьте первую продажу 📊',
    addFirstSaleSub: 'Введите продажи за сегодня чтобы увидеть панель P&L.',
    saveAndContinue: 'Сохранить и продолжить →', skipForNow: 'Пропустить сейчас',
    skipSetup: 'Пропустить настройку', allSet: 'Всё готово!', goToDashboard: 'Перейти на панель →',
    stepOf: 'Шаг', of: 'из', freeTrial: 'Бесплатный пробный период', daysLeft: 'дней осталось',
    trialExpired: 'Ваш пробный период закончился. Выберите план.',
    trialActive: 'У вас осталось', daysLeftInTrial: 'дней пробного периода.',
    startFree: '30 дней бесплатно. Без кредитной карты.',
    monthly: 'Ежемесячно', yearly: 'Ежегодно', bestValue: 'Лучшее предложение',
    subscribeMonthly: 'Подписаться ежемесячно', subscribeYearly: 'Подписаться ежегодно',
    startFreeTrial: 'Начать пробный период', alreadyAccount: 'Уже есть аккаунт?',
    action: 'Действие', primeCost: 'Первичные затраты', bevMix: 'Доля напитков',
    pleaseEnterDate: 'Пожалуйста, введите дату и хотя бы одну сумму продаж.',
    pleaseEnterDateAmount: 'Пожалуйста, введите дату и сумму.',
    pleaseEnterName: 'Пожалуйста, введите название ресторана.',
    errorDelete: 'Удалить эту запись?', errorDeleteExpense: 'Удалить этот расход?',
    dailyRevenue: 'Ежедневная выручка', monthTrend: 'Тренд за 6 месяцев',
    lastPeriod: 'Прошлый период', revenue: 'Выручка', ofWeeklyTargetPct: 'от еженедельной цели',
  },
  ko: {
    dashboard: '대시보드', enterData: '데이터 입력', expenses: '지출',
    inventory: '재고', aiAdvisor: 'AI 어드바이저', settings: '설정',
    signOut: '로그아웃', totalRevenue: '총 매출', foodCostPct: '식재료 원가 %',
    laborCostPct: '인건비 %', netProfit: '순이익', daysTracked: '기록된 일수',
    margin: '마진', target: '목표', pandlSummary: 'P&L 요약',
    foodSales: '음식 매출', beverageSales: '음료 매출', totalRevenueLine: '총 매출',
    foodCost: '식재료 원가', beverageCost: '음료 원가', labor: '인건비', rent: '임대료',
    utilities: '공과금', other: '기타', netProfitLine: '순이익',
    costBreakdown: '원가 분석', avgCheck: '평균 객단가', totalCovers: '총 고객 수',
    downloadPL: 'P&L 보고서 다운로드 (Excel)', vsPrevMonth: '전월 대비',
    vsSameLastYear: '전년 동월 대비', backToCurrentMonth: '현재 달로 돌아가기',
    noDataYet: '이번 달 데이터가 없습니다.', goToEnterData: '데이터 입력으로 이동하여 첫 매출을 추가하세요.',
    weeklyTarget: '주간 매출 목표', weeklyTargetReached: '이번 주 목표 달성!',
    toGo: '남음', ofWeeklyTarget: '주간 목표 달성률',
    bestDay: '최고의 날', worstDay: '최저의 날', busiestDay: '가장 바쁜 날',
    covers: '명', foodCostAlert: '식재료 원가 경고', threshold: '임계값',
    aboveTarget: '목표 초과. 구매 및 재고를 확인하세요.',
    approaching: '식재료 원가가 임계값에 근접', keepEye: '경고 임계값에 근접. 구매를 모니터링하세요.',
    addUpdateSales: '일일 매출 추가 또는 업데이트', date: '날짜', coversGuests: '고객 수',
    foodSalesAmt: '음식 매출 ($)', beverageSalesAmt: '음료 매출 ($)',
    saveEntry: '저장', saving: '저장 중...', saved: '저장되었습니다!', thisMonth: '이번 달',
    entries: '건', noEntriesYet: '이번 달 기록 없음.', edit: '수정',
    saveChanges: '변경사항 저장', cancel: '취소', downloadExcel: 'Excel 다운로드',
    editEntry: '항목 수정', logExpense: '지출 기록', category: '카테고리',
    amount: '금액 ($)', description: '설명', saveExpense: '지출 저장',
    noExpensesYet: '지출 없음.', editExpense: '지출 수정',
    subcategory: '하위 카테고리', selectSubcategory: '하위 카테고리 선택...',
    catFoodCost: '식재료 원가', catBevCost: '음료 원가', catLabor: '인건비',
    catRent: '임대료', catUtilities: '공과금', catMarketing: '마케팅',
    catMaintenance: '유지보수', catOther: '기타',
    meatSeafood: '육류 & 해산물', produce: '채소 & 과일', dairyEggs: '유제품 & 계란',
    dryGoods: '건식품', otherFood: '기타 식품', coffeeTea: '커피 & 차',
    softDrinks: '청량음료', alcohol: '주류', otherBev: '기타 음료',
    inventoryCount: '재고 조사', openingInventory: '기초 재고 - 월초', closingInventory: '기말 재고 - 월말',
    totalOpening: '기초 합계', totalClosing: '기말 합계',
    saveOpeningInventory: '기초 재고 저장', saveClosingInventory: '기말 재고 저장',
    realFoodCost: '실제 식재료 원가 계산', plusPurchases: '구매액 추가',
    minusClosing: '기말 재고 차감', inventoryVariance: '재고 차이',
    catMeatSeafood: '육류 및 해산물', catProduce: '채소 및 과일', catDairyEggs: '유제품 및 계란',
    catDryGoods: '건식품', catBevCoffee: '음료 - 커피 및 차', catBevSoft: '음료 - 청량음료',
    catBevAlcohol: '음료 - 주류', catBevOther: '기타',
    aiAdvisorTitle: 'Claude 기반 AI 어드바이저',
    addDataFirst: 'AI 인사이트를 위해 매출 데이터를 추가하세요.',
    analyzing: '데이터 분석 중...', claudeReviewing: 'Claude가 데이터를 검토 중입니다.',
    readyToAnalyze: '분석 준비 완료', generateInsights: 'AI 인사이트 생성',
    regenerateInsights: '인사이트 재생성', couldNotGenerate: '생성 실패. API 키를 확인하세요.',
    benchmarks: '기준: 식재료 28-32% 인건비 28-35% 순이익 >10%',
    restaurantSettings: '레스토랑 설정', restaurantName: '레스토랑 이름', currency: '통화',
    targetsAlerts: '목표 및 알림', weeklyRevenueTarget: '주간 매출 목표 ($)',
    weeklyTargetHint: '대시보드에 진행 표시줄 표시', foodCostAlertThreshold: '식재료 원가 경고 임계값 (%)',
    foodCostAlertHint: '원가가 임계값 초과 시 경고 표시',
    language: '언어', saveSettings: '설정 저장', errorSaving: '오류. 다시 시도하세요.',
    signIn: '로그인', signUp: '회원가입', email: '이메일', password: '비밀번호',
    createAccount: '계정 만들기', alreadyHaveAccount: '이미 계정이 있나요?',
    dontHaveAccount: '계정이 없나요?', pleaseWait: '잠시만 기다려 주세요...',
    restaurantPL: '레스토랑 P&L 및 AI 어드바이저',
    welcomeTitle: 'WinProfit에 오신 것을 환영합니다! 👋', welcomeSub: '2분 안에 레스토랑을 설정해 드리겠습니다.',
    continueBtn: '계속 →', addFirstSale: '첫 매출 추가 📊',
    addFirstSaleSub: '오늘의 매출을 입력하여 P&L 대시보드를 확인하세요.',
    saveAndContinue: '저장하고 계속 →', skipForNow: '나중에',
    skipSetup: '설정 건너뛰기', allSet: '준비 완료!', goToDashboard: '대시보드로 이동 →',
    stepOf: '단계', of: '/', freeTrial: '무료 체험', daysLeft: '일 남음',
    trialExpired: '무료 체험이 종료되었습니다. 플랜을 선택하세요.',
    trialActive: '무료 체험이', daysLeftInTrial: '일 남았습니다.',
    startFree: '30일 무료. 신용카드 불필요.',
    monthly: '월간', yearly: '연간', bestValue: '최고의 가치',
    subscribeMonthly: '월간 구독', subscribeYearly: '연간 구독',
    startFreeTrial: '무료 체험 시작', alreadyAccount: '이미 계정이 있나요?',
    action: '액션', primeCost: '주요 비용', bevMix: '음료 비율',
    pleaseEnterDate: '날짜와 최소 하나의 판매 금액을 입력하세요.',
    pleaseEnterDateAmount: '날짜와 금액을 입력하세요.', pleaseEnterName: '레스토랑 이름을 입력하세요.',
    errorDelete: '이 항목을 삭제하시겠습니까?', errorDeleteExpense: '이 지출을 삭제하시겠습니까?',
    dailyRevenue: '일일 매출', monthTrend: '6개월 매출 추세',
    lastPeriod: '이전 기간', revenue: '매출', ofWeeklyTargetPct: '주간 목표 달성률',
  },
  ja: {
    dashboard: 'ダッシュボード', enterData: 'データ入力', expenses: '費用',
    inventory: '在庫', aiAdvisor: 'AIアドバイザー', settings: '設定',
    signOut: 'ログアウト', totalRevenue: '総売上', foodCostPct: '食材原価率 %',
    laborCostPct: '人件費率 %', netProfit: '純利益', daysTracked: '記録日数',
    margin: 'マージン', target: '目標', pandlSummary: 'P&L サマリー',
    foodSales: '料理売上', beverageSales: 'ドリンク売上', totalRevenueLine: '総売上',
    foodCost: '食材原価', beverageCost: 'ドリンク原価', labor: '人件費', rent: '賃料',
    utilities: '光熱費', other: 'その他', netProfitLine: '純利益',
    costBreakdown: 'コスト分析', avgCheck: '客単価', totalCovers: '総客数',
    downloadPL: 'P&Lレポートをダウンロード（Excel）', vsPrevMonth: '前月比',
    vsSameLastYear: '前年同月比', backToCurrentMonth: '当月に戻る',
    noDataYet: '今月のデータはありません。', goToEnterData: 'データ入力で最初の売上を追加してください。',
    weeklyTarget: '週間売上目標', weeklyTargetReached: '今週の目標達成！',
    toGo: '残り', ofWeeklyTarget: '週間目標達成率',
    bestDay: '最高の日', worstDay: '最低の日', busiestDay: '最も忙しい日', covers: '名',
    foodCostAlert: '食材原価アラート', threshold: 'しきい値',
    aboveTarget: '目標超過。仕入れと在庫を確認してください。',
    approaching: '食材原価がしきい値に近づいています', keepEye: 'アラートのしきい値に近づいています。',
    addUpdateSales: '日次売上の追加または更新', date: '日付', coversGuests: '客数',
    foodSalesAmt: '料理売上（$）', beverageSalesAmt: 'ドリンク売上（$）',
    saveEntry: '保存', saving: '保存中...', saved: '保存しました！', thisMonth: '今月',
    entries: '件', noEntriesYet: '今月の記録はありません。', edit: '編集',
    saveChanges: '変更を保存', cancel: 'キャンセル', downloadExcel: 'Excelをダウンロード',
    editEntry: 'エントリを編集', logExpense: '費用を記録', category: 'カテゴリー',
    amount: '金額（$）', description: '説明', saveExpense: '費用を保存',
    noExpensesYet: '費用はまだありません。', editExpense: '費用を編集',
    subcategory: 'サブカテゴリー', selectSubcategory: 'サブカテゴリーを選択...',
    catFoodCost: '食材原価', catBevCost: 'ドリンク原価', catLabor: '人件費',
    catRent: '賃料', catUtilities: '光熱費', catMarketing: 'マーケティング',
    catMaintenance: 'メンテナンス', catOther: 'その他',
    meatSeafood: '肉類・海鮮', produce: '野菜・果物', dairyEggs: '乳製品・卵',
    dryGoods: '乾物', otherFood: 'その他食品', coffeeTea: 'コーヒー・お茶',
    softDrinks: 'ソフトドリンク', alcohol: 'アルコール', otherBev: 'その他飲料',
    inventoryCount: '在庫カウント', openingInventory: '期首在庫 - 月初', closingInventory: '期末在庫 - 月末',
    totalOpening: '期首合計', totalClosing: '期末合計',
    saveOpeningInventory: '期首在庫を保存', saveClosingInventory: '期末在庫を保存',
    realFoodCost: '実際の食材原価計算', plusPurchases: '仕入れを追加',
    minusClosing: '期末在庫を差引く', inventoryVariance: '在庫差異',
    catMeatSeafood: '肉類・海鮮', catProduce: '野菜・果物', catDairyEggs: '乳製品・卵',
    catDryGoods: '乾物', catBevCoffee: '飲料 - コーヒー・お茶', catBevSoft: '飲料 - ソフトドリンク',
    catBevAlcohol: '飲料 - アルコール', catBevOther: 'その他',
    aiAdvisorTitle: 'Claude搭載AIアドバイザー',
    addDataFirst: 'AIインサイトを得るために売上データを追加してください。',
    analyzing: 'データを分析中...', claudeReviewing: 'Claudeがデータを確認しています。',
    readyToAnalyze: '分析準備完了', generateInsights: 'AIインサイトを生成',
    regenerateInsights: 'インサイトを再生成', couldNotGenerate: '生成できませんでした。APIキーを確認してください。',
    benchmarks: '基準：食材28-32% 人件費28-35% 純利益>10%',
    restaurantSettings: 'レストラン設定', restaurantName: 'レストラン名', currency: '通貨',
    targetsAlerts: '目標とアラート', weeklyRevenueTarget: '週間売上目標（$）',
    weeklyTargetHint: 'ダッシュボードに進捗バーを表示', foodCostAlertThreshold: '食材原価アラートのしきい値（%）',
    foodCostAlertHint: '食材原価がしきい値を超えたときに警告を表示',
    language: '言語', saveSettings: '設定を保存', errorSaving: 'エラー。もう一度お試しください。',
    signIn: 'ログイン', signUp: '登録', email: 'メール', password: 'パスワード',
    createAccount: 'アカウント作成', alreadyHaveAccount: 'アカウントをお持ちですか？',
    dontHaveAccount: 'アカウントをお持ちでないですか？', pleaseWait: 'お待ちください...',
    restaurantPL: 'レストランP&L・AIアドバイザー',
    welcomeTitle: 'WinProfitへようこそ！👋', welcomeSub: '2分でレストランを設定しましょう。',
    continueBtn: '続ける →', addFirstSale: '最初の売上を追加 📊',
    addFirstSaleSub: '今日の売上を入力してP&Lダッシュボードを確認しましょう。',
    saveAndContinue: '保存して続ける →', skipForNow: '後で',
    skipSetup: 'セットアップをスキップ', allSet: '準備完了！', goToDashboard: 'ダッシュボードへ →',
    stepOf: 'ステップ', of: '/', freeTrial: '無料トライアル', daysLeft: '日残り',
    trialExpired: '無料トライアルが終了しました。プランを選択してください。',
    trialActive: '無料トライアルが残り', daysLeftInTrial: '日です。',
    startFree: '30日間無料。クレジットカード不要。',
    monthly: '月払い', yearly: '年払い', bestValue: '最もお得',
    subscribeMonthly: '月払いで登録', subscribeYearly: '年払いで登録',
    startFreeTrial: '無料トライアルを開始', alreadyAccount: 'アカウントをお持ちですか？',
    action: 'アクション', primeCost: 'プライムコスト', bevMix: 'ドリンク比率',
    pleaseEnterDate: '日付と少なくとも1つの売上金額を入力してください。',
    pleaseEnterDateAmount: '日付と金額を入力してください。', pleaseEnterName: 'レストラン名を入力してください。',
    errorDelete: 'このエントリを削除しますか？', errorDeleteExpense: 'この費用を削除しますか？',
    dailyRevenue: '日次売上', monthTrend: '6ヶ月売上トレンド',
    lastPeriod: '前期', revenue: '売上', ofWeeklyTargetPct: '週間目標達成率',
  },
};

export const languageNames = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  km: 'ខ្មែរ',
  zh: '中文（简体）',
  'zh-TW': '中文（繁體）',
  th: 'ภาษาไทย',
  ru: 'Русский',
  ko: '한국어',
  ja: '日本語',
};

export function t(lang, key) {
  const langData = translations[lang] || translations['en'];
  return langData[key] || translations['en'][key] || key;
}

export default translations;
